<template>
  <div class="container mt-3">
    <!-- ------- -->
    <!-- NUMBERS -->
    <!-- ------- -->
    <div class="col-sm-6 align-self-center bb-roll-panel-column">
      <span class="bb-sub-hdg bb-roll-panel-heading"><p>Roll</p></span>
      <!-- ------------------------------------------ -->
      <!-- 1. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="1"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(1)"
          @click="numberClick"
          alt="number image'"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 2. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="2"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(2)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 3. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="3"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(3)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 4. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="4"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(4)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 5. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="5"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(5)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 6. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="6"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(6)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 7. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="7"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(7)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 8. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="8"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(8)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 9. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="9"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(9)"
          @click="numberClick"
          alt="number image"
        />
      </div>
      <!-- ------------------------------------------ -->
      <!-- 10. -->
      <div class="mt-2 mb-2 bb-roll-panel-image-row">
        <img
          id="10"
          class="img-fluid rounded bb-img-norm-border bb-hover bb-roll-panel-image"
          :src="getNumberImg(10)"
          @click="numberClick"
          alt="number image"
        />
      </div>
    </div>
  </div>
</template>

<script>
//==========================================================
// imports
//---------
import getNumberImage from '../helpers/getNumberImage'
//==========================================================
// scripts
//---------
export default {
  name: 'NumberPanel',
  //==========================================================
  // data
  //------
  data() {
    return {
      toggleDesc: true,
      save_number_id: '',
    }
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //================================================
    // get number image
    //------------------
    getNumberImg(number) {
      let image = getNumberImage(number)
      return image
    },
    //================================================
    // number click
    //--------------
    numberClick(e) {
      let id = e.target.id // number id
      var number_id = document.getElementById(id)
      //-------------------------------
      // reset if click on same number
      //-------------------------------
      if (id == this.save_number_id) {
        number_id.style.borderColor = '#c2ccd6'
        number_id.style.borderWidth = '0.5px'
        number_id.style.opacity = '0.4'
        this.save_number_id = ''
        let parm = {
          reset: true,
        }
        //-----------------------
        // change slots capacity
        //-----------------------
        this.changeSlotsOpacity(parm)
        //----------------------
        // different id clicked
        //----------------------
      } else {
        //----------------------
        // highlight new number
        //----------------------
        number_id.style.borderColor = 'white'
        number_id.style.borderWidth = '3px'
        number_id.style.opacity = '1.0'
        //-------------------
        // reset save number
        //-------------------
        if (this.save_number_id != '') {
          var number_save = document.getElementById(this.save_number_id)
          number_save.style.borderColor = '#c2ccd6'
          number_save.style.borderWidth = '0.5px'
          number_save.style.opacity = '0.4'
        }
        //-----------------
        // save clicked id
        //-----------------
        this.save_number_id = id
        //-------------------
        // set slots opacity
        //-------------------
        let parm = {
          id: id,
        }
        this.changeSlotsOpacity(parm)
      }
      //--------------------
      // set selected image
      //--------------------
      let selected_image =
        '/assets/images/bbRollNumber' + this.save_number_id + '.png'
      //----------
      // set parm
      //----------
      let selection_parm = {
        number: Number(this.save_number_id),
        image: selected_image,
      }
      //----------------
      // send selection
      //----------------
      this.emitter.emit('panel-number-selected', selection_parm)
    },
    //================================================
    // change slots opacity (only highlight selected)
    //----------------------
    changeSlotsOpacity(parm) {
      for (let i = 1; i <= 10; i++) {
        var slot = document.getElementById(String(i))
        slot.style.opacity = '1.0'
        if (String(i) != parm.id && !parm.reset) {
          if (slot) {
            slot.style.opacity = '0.4'
          }
        }
      }
    },
  },
  //==========================================================
  // mounted
  //--------
  mounted() {
    //========================================================
    // disable panel number
    //----------------------
    this.emitter.on('disable-panel-number', (selected_number) => {
      var number_id = document.getElementById(String(selected_number))
      //----------------------
      // hide selected number
      //----------------------
      number_id.style.visibility = 'hidden'
    }),
      //========================================================
      // reset numbers
      //---------------
      this.emitter.on('reset-panel-numbers', () => {
        //-------------------
        // reset all numbers
        //-------------------
        for (let i = 1; i <= 10; i++) {
          var slot = document.getElementById(String(i))
          // slot.onclick = null;
          slot.style.visibility = 'visible'
          slot.style.opacity = '1.0'
          slot.style.borderColor = '#c2ccd6'
          slot.style.borderWidth = '0.5px'
        }
      })
    //========================================================
    // reset number
    //--------------
    this.emitter.on('reset-panel-number', (selected_number) => {
      var number_id = document.getElementById(String(selected_number))
      //-----------------------
      // reset selected number
      //-----------------------
      number_id.style.borderColor = '#c2ccd6'
      number_id.style.borderWidth = '0.5px'
      this.save_number_id = ''
      let parm = {
        reset: true,
      }
      //-----------------------
      // change slots opacity
      //-----------------------
      this.changeSlotsOpacity(parm)
    })
  },
}
</script>

<style>
#noImg {
  visibility: hidden;
}

.bb-roll-panel-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bb-roll-panel-heading {
  display: block;
  width: 100%;
  text-align: center;
}

.bb-roll-panel-image-row {
  display: flex;
  justify-content: center;
  width: 100%;
}

.bb-roll-panel-image {
  width: 78px;
  max-width: 78px;
  height: auto;
}

.slotBtn:disabled {
  pointer-events: none;
  opacity: 0.1;
}
</style>
